import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import IcseMarkRegisteration from "./IcseMarkRegisteration";
import PrelimsMarkEntry from "./PrelimsMarkEntry";

function Icse() {
  const navigate = useNavigate();

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);

  const handleCheckResult = () => {
    navigate('/PrelimsResult'); // Navigate to the IcseResult page
  };

  return (
    <div>
      <PrelimsMarkEntry/>
     
    
      <div style={{marginTop:'0px', padding: '20px', marginLeft:'380px' }}>
       
      <button 
  onClick={handleCheckResult} 
  style={{
    backgroundColor: 'black', 
    border: 'none', 
    color: 'white', 
    fontSize: '16px', 
    cursor: 'pointer', 
    padding: '10px 20px', 
    position: 'relative', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    borderRadius: '5px', // Optional: for rounded corners
  }}
>
  <span style={{ marginRight: '10px' , fontSize: '18px'}}><b>Check ICSE Result</b></span>
  <div style={{
    width: '0', 
    height: '0', 
    borderTop: '10px solid transparent', 
    borderBottom: '10px solid transparent', 
    borderLeft: '15px solid white' // Arrow color
  }} />
</button>

      </div>

      
    </div>
  );
}

export default Icse;